<script setup>
const { y } = useWindowScroll()
</script>

<template>
  <div
    class="flex flex-col h-full"
    :class="{
      'h-max': y > 60
    }"
  >
    <Header :is-scrolled="true" />
    <SearchStickyHeader />
    <slot />
    <FooterGeneric />
  </div>
</template>
